 
import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#065535',
    darken1: colors.purple.darken2,
  },
  success: {
      base: '#FF6100',
      darken1: colors.purple.darken2,
  },
  icoevsecondary: '#B9CADD', 
  anchor: '#1976d2', 
  icoevtitle: '#0099CC',
  light: '#FEFEFE'
}